<ng-container *abcLet="res$ | async as res">
  <div class="containerDetail resource_event_border">
    <div class="detailContainerMaterialExpense">
      <div fxLayout="row" class="icon-container">
        <mat-icon
          class="iconHeaderMaterialExpense"
          [svgIcon]="res.svgName(this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.iconName)"
        ></mat-icon>
        <span class="resource_event_boldLabel">{{
          this.resourcesNavigationContext.resourceEventGroup.resource.name
        }}</span>
      </div>
      <resource-navigation></resource-navigation>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="startContainer">
        <div class="dateHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'date')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Date')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'date'"
            [useMaskBehavior]="'true'"
            [value]="this.resourceEvent?.date"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
        <div class="timeHolder">
          <abc-date-box
            (onValueChanged)="safeSetValue($event, 'time')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Time')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [type]="'time'"
            [useMaskBehavior]="true"
            [value]="this.resourceEvent?.time"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-date-box>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutWrap fxLayoutGap="16px" class="endContainer">
        <div class="inputAjustment">
          <abc-number-box
            (onValueChanged)="safeSetValue($event, 'resultValue')"
            [disabled]="this.isDisabled"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Amount')"
            [showClearButton]="true"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.resultValue"
            [ngStyle]="{ width: '230px' }"
            [ngStyle.xs]="{ width: '380px' }"
            [format]="this.resourceEvent?.valueFormat"
            valueChangeEvent="keyup"
          >
          </abc-number-box>
        </div>
      </div>
      <div fxLayout="row">
        <div class="dateHolder" fxLayout.xs="column">
          <abc-text-area
            (onValueChanged)="safeSetValue($event, 'comment')"
            [disabled]="this.isDisabled"
            [height]="'100px'"
            [labelMode]="'floating'"
            [label]="res.get('Resources-ResourceEvent-Description')"
            [stylingMode]="'filled'"
            [value]="this.resourceEvent?.comment"
            [ngStyle]="{ width: '652px' }"
            [ngStyle.xs]="{ width: '380px' }"
            valueChangeEvent="keyup"
          >
          </abc-text-area>
        </div>
      </div>
    </div>
  </div>
</ng-container>
